<template>
  <Modal
      id="UserFeeEdit"
      width="50%"
      :open="visible"
      @cancel="visible = !visible"
      @ok="submit"
      :title="title"
      :destroyOnClose="true"
  >
    <Row align="middle" justify="center">
      <Col span="18" >
        <Row>
          <Col span="24">
            <Form
                ref="userFeeForm"
                :model="form"
                layout="vertical"
                :rules="validateRules"
            >
              <Row justify="space-around">
                <Col span="10">
                  <FormItem :label="$t('userFee.field.id_cha_poi')" name="idChaPoi">
                    <Select
                                v-model:value="form.idChaPoi"
                                :placeholder="$t('userFee.validate.required.id_cha_poi')"
                                :dropdownStyle="{ zIndex: 9999999950 }"
                        >
                          <SelectOption :key="sk" v-for="(item,sk) in chargingStationList" :value="item['idChaPoi']">{{ item['chargeBoxId'] }}</SelectOption>
                        </Select>
                  </FormItem>
                </Col>
                <Col span="10">
                  <FormItem :label="$t('userFee.field.id_use')" name="idUse">
                    <Select
                        v-model:value="form.idUse"
                        show-search
                        :placeholder="$t('public.pleaseSelect')"
                        style="width: 100%"
                        :options="userList"
                        :filter-option="filterOption"
                        @change="handleChangeUser"
                        allowClear
                    ></Select>
                  </FormItem>
                </Col>
                <Col span="10">
                  <FormItem :label="$t('userFee.field.id_spa')" name="idSpa">
                    <Cascader v-model:value="selectedSpace" :options="spaceOptions"  @change="changeSpaceCascader" placeholder="Please select" />
                  </FormItem>
                </Col>
                <Col span="10">
                  <FormItem :label="$t('userFee.field.fee_amount')" name="feeAmount">
                    <InputNumber
                        :placeholder="$t('userFee.validate.required.fee_amount')"
                        v-model:value="form.feeAmount"
                        :step="0.01"
                    >
                    </InputNumber>
                  </FormItem>
                </Col>
                <Col span="10">
                  <FormItem :label="$t('userFee.field.start_month')" name="startMonth">
                    <MonthPicker valueFormat="YYYY-MM" v-model:value="form.startMonth" :popupStyle="{ zIndex: 9999999950 }"></MonthPicker>
                  </FormItem>
                </Col>
                
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  </Modal>
</template>
<script>
export default {
  name: "UserFeeEdit",
}
</script>
<script setup>
import {
  Modal,
  Row,
  Col,
  Form,
  FormItem,
  Input,
  InputNumber,
  message,
  Select,
  SelectOption,
  Textarea,
  Cascader,
  Button,
  InputPassword,
  MonthPicker
} from "ant-design-vue";
import { MinusCircleOutlined, PlusOutlined  } from "@ant-design/icons-vue";
import {UserFeeAdd, UserFeeEdit} from "@/api/userFee";
import {  ChargingStationListAllBackend } from "@/api/chargingStation"
import {UserListAll} from "@/api/user";
import {SpaceGetSpaceIdsByUserId, SpaceGetTreeByUserId, SpaceInfoByUserId,SpaceInfoBySpaceId} from "@/api/space";
import {reactive, ref, toRefs, watch} from "vue";
import {useI18n} from "vue-i18n";

const i18n = useI18n()
const emits = defineEmits(['updateList'])

let userFeeForm = ref()
let userList = ref([])
let chargingStationList = ref([])
let spaceOptions = ref([])
let selectedSpace = ref([])
let visible = ref(false)
let title = ref("")
let actionType = ref("")


const validateRules = ref({
  idUse: [
    {
      required: true,
      message: i18n.t("userFee.validate.required.id_use"),
      trigger: "change",
      type: "number",
    },
  ],
  idChaPoi: [
    {
      required: true,
      message: i18n.t("userFee.validate.required.id_cha_poi"),
      trigger: "change",
      type: "number",
    },
  ],
  idSpa: [
    {
      required: true,
      message: i18n.t("userFee.validate.required.id_spa"),
      trigger: "change",
      type: "number",
    },
  ],
  startMonth: [
    {
      required: true,
      message: i18n.t("userFee.validate.required.start_month"),
      trigger: "change",
      type: "string",
    },
  ],
  feeAmount: [
    {
      required: true,
      message: i18n.t("userFee.validate.required.fee_amount"),
      trigger: "change",
      type: "number",
    },
  ],
})


const data = reactive({
  form: {
  },
})
const {form} = toRefs(data)

async function addShow() {
  title.value = i18n.t("public.name.add");
  actionType.value = "add";
  _resetData();
  init()
  visible.value = true;
}


async function editShow(obj) {
  actionType.value = "edit";
  title.value = i18n.t("public.name.edit");
  _resetData();
  init()
  form.value = JSON.parse(JSON.stringify(obj));
  visible.value = true;
}

function getChargingStationlist() {
  const api = new ChargingStationListAllBackend();
  api.get().then((response) => {
    if (0 === parseInt(response.data.code)) {
        chargingStationList.value = response.data.data;
    } else {
        if(response.data.code !== undefined){message.error(this.$t("errorMsg." + response.data.code));}
    }
  });
}

function getUserList() {
  userList.value = []
  const api = new UserListAll();
  api.get().then((response) => {
    if (0 === parseInt(response.data.code)) {
      const data = response.data.data
      
      userList.value = data.map(item => 
      ({
        value: item.idUse,
        label: item.account
      }));
    } else {
      if (response.data.code !== undefined) {
        message.error(i18n.t("errorMsg." + response.data.code));
      }
    }
  });
}

// 初始化
function init() {
  // 获取用户列表
  getUserList()
  getChargingStationlist();
  // 获取车位树
  // const sApi = new SpaceGetTree()
  // sApi.get().then(res => {
  //   spaceOptions.value = res.data.data
  //   // 获取用户关联的车位ID
  //   // if (form.value.idSpa) {
  //   //   const gsApi = new SpaceInfoBySpaceId()
  //   //   gsApi.get({spaceId:form.value.idSpa}).then(res => {
  //   //     handleList("space" ,res.data.data)
  //   //   })
  //   // }
  // })
}

function handleList(t, vList) {
  if (!vList) {
    return
  }
 
    let rL = []
    vList.forEach(item => {
      if (t === "unit") {
        rL.push(item.unitId)
      } else {
        rL.push(item.spaceId)
      }
    })
    addItem(t, rL)
  
}


function addItem (t, v) {
  if (t === "unit") {
    if (!form.value.utils) {
      form.value.utils = []
    }
    form.value.utils.push({
      value: v,
      key: Date.now(),
    })
    return
  }
  if (!spaceOptions.value) {
    spaceOptions.value = []
  }
  spaceOptions.value.push({
    value: v,
    key: Date.now(),
  })
}

function submit() {
  userFeeForm.value?.validate().then(() => {
    let api;
    switch (actionType.value) {
      case "add":
        api = new UserFeeAdd();
        break;
      case "edit":
        api = new UserFeeEdit();
        break;
      default:
        return false;
    }

    api.post(form.value).then(response => {
      if (0 === parseInt(response.data.code)) {
        message.success(i18n.t("succeedMsg.0"));
        emits("updateList", response.data.data);
        visible.value = false;
      } else {
        if(response.data.code !== undefined){message.error(i18n.t("errorMsg." + response.data.code));}
      }
    })
  })
}

function _resetData() {
  form.value = {
  };
}


function handleChange() {}

function handleChangeUser() {
  // 获取车位树
  const sApi = new SpaceGetTreeByUserId()
  sApi.get({
    userId: form.value.idUse
  }).then(res => {
    spaceOptions.value = res.data.data
    // 获取用户关联的车位ID
    // if (form.value.idSpa) {
    //   const gsApi = new SpaceInfoBySpaceId()
    //   gsApi.get({spaceId:form.value.idSpa}).then(res => {
    //     handleList("space" ,res.data.data)
    //   })
    // }
  })
}

// 搜索框过滤筛选
function filterOption(input, option) {
  return option.label.indexOf(input) >= 0;
}


function changeSpaceCascader(value, selectedOptions) {
  console.log(value)
  console.log(selectedOptions)

  form.value.idSpa = value[2]
  console.log(form.idSpa)
}



defineExpose({
  addShow,
  editShow
})
</script>

<style lang="less">
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}
.dynamic-delete-button:hover {
  color: #777;
}
.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
